import { queryOptions } from '@tanstack/react-query';
import { FeatureSetKey } from '@squareup/shared-types-protos/squareup/featurama/feature_sets';
import type { BulkRetrieveFeatureSetStatusesRequest, BulkRetrieveFeatureStatusesRequest } from '@squareup/shared-types-protos/squareup/featurama/service.js';
import { Feature } from '@squareup/shared-types-protos/squareup/sub2/data';

const ALL_FEATURES = Object.values(Feature).filter((key: Feature | string) => typeof key !== 'string' && key !== Feature.DO_NOT_USE);
const ALL_FEATURE_SETS = Object.values(FeatureSetKey).filter((key: FeatureSetKey | string) => typeof key !== 'string' && key !== FeatureSetKey.FEATURE_SET_DO_NOT_USE);

export const featurama = {
  keys: {
    root: () => ['featurama'],
    bulkRetrieveFeatureStatuses: () => [...featurama.keys.root(), 'externalBulkRetrieveFeatureStatuses'],
    bulkRetrieveFeatureSetStatuses: () => [...featurama.keys.root(), 'externalBulkRetrieveFeatureSetStatuses'],
  },
  // Methods
  bulkRetrieveFeatureStatuses: (params: Partial<BulkRetrieveFeatureStatusesRequest> = {}) => queryOptions({
    queryKey: [...featurama.keys.bulkRetrieveFeatureStatuses(), { params }],
    queryFn: async () => {
      const { bulkRetrieveFeatureStatuses } = await import('../api/featurama/rpc');
      const requestParams = { keys: ALL_FEATURES, ...params };
      return bulkRetrieveFeatureStatuses(requestParams);
    },
    staleTime: Number.POSITIVE_INFINITY,
  }),
  bulkRetrieveFeatureSetStatuses: (params: Partial<BulkRetrieveFeatureSetStatusesRequest> = {}) => queryOptions({
    queryKey: [...featurama.keys.bulkRetrieveFeatureSetStatuses(), { params }],
    queryFn: async () => {
      const { bulkRetrieveFeatureSetStatuses } = await import('../api/featurama/rpc');
      const requestParams = { featureSetKeys: ALL_FEATURE_SETS, ...params };
      return bulkRetrieveFeatureSetStatuses(requestParams);
    },
    staleTime: Number.POSITIVE_INFINITY,
  }),
};
